const STATUS_PENDENTE = 1
const STATUS_BLOQUEADO = 2
const STATUS_APROVADO = 3
const STATUS_AGUARDANDO_FATURAMENTO = 4
const STATUS_ERRO = 5
const STATUS_CANCELADO = 6
const STATUS_FATURADO = 7
const STATUS_PARCIALMENTE_FATURADO = 10
const STATUS_EM_TRANSPORTE = 8
const STATUS_FINALIZADO = 9
const STATUS_PARCIALMENTE_DEVOLVIDO = 11
const STATUS_DEVOLVIDO = 12

const TIPO_COBRANCA_LIGACAO = 1
const TIPO_COBRANCA_EMAIL = 2
const TIPO_COBRANCA_APLICATIVO = 3

const DESCRICAO_TIPO_COBRANCA = {
  [TIPO_COBRANCA_LIGACAO]: 'Ligação ou SMS',
  [TIPO_COBRANCA_EMAIL]: 'E-mail',
  [TIPO_COBRANCA_APLICATIVO]: 'Aplicativo',
}

const DESCRICAO_STATUS = {
  [STATUS_PENDENTE]: 'Pendente',
  [STATUS_BLOQUEADO]: 'Bloqueado',
  [STATUS_APROVADO]: 'Aprovado',
  [STATUS_AGUARDANDO_FATURAMENTO]: 'Aguardando faturamento',
  [STATUS_FATURADO]: 'Faturado',
  [STATUS_PARCIALMENTE_FATURADO]: 'Parcialmente faturado',
  [STATUS_ERRO]: 'Erro',
  [STATUS_CANCELADO]: 'Cancelado',
  [STATUS_EM_TRANSPORTE]: 'Em transporte',
  [STATUS_FINALIZADO]: 'Finalizado',
  [STATUS_PARCIALMENTE_DEVOLVIDO]: 'Parcialmente devolvido',
  [STATUS_DEVOLVIDO]: 'Devolvido',
}

const DETALHES_STATUS = {
  [STATUS_PENDENTE]: 'O pedido foi criado, mas ainda não passou por análise ou validação.',
  [STATUS_BLOQUEADO]: 'O pedido está temporariamente bloqueado por alguma pendência, como crédito, estoque ou validação fiscal.',
  [STATUS_APROVADO]: 'O pedido foi aprovado e está liberado para os próximos processos internos.',
  [STATUS_AGUARDANDO_FATURAMENTO]: 'O pedido foi aprovado e está aguardando a geração da nota fiscal ou confirmação de faturamento.',
  [STATUS_FATURADO]: 'A nota fiscal foi emitida e o pedido está pronto para expedição ou entrega.',
  [STATUS_PARCIALMENTE_FATURADO]: 'Um ou mais documentos fiscais foram emitidos, mas ainda há itens pendentes de faturamento.',
  [STATUS_ERRO]: 'Ocorreu uma falha durante o processamento ou emissão da nota fiscal, exigindo intervenção manual.',
  [STATUS_CANCELADO]: 'O pedido foi cancelado e não será mais processado ou faturado.',
  [STATUS_EM_TRANSPORTE]: 'O pedido já foi despachado e encontra-se em processo de entrega ao cliente.',
  [STATUS_FINALIZADO]: 'O pedido foi entregue e todas as etapas do processo foram concluídas com sucesso.',
  [STATUS_PARCIALMENTE_DEVOLVIDO]: 'Parte dos itens do pedido foi devolvida e o estoque foi recomposto.',
  [STATUS_DEVOLVIDO]: 'Todos os itens do pedido foram devolvidos e o estoque foi recomposto.',
}

const COR_STATUS = {
  [STATUS_PENDENTE]: 'warning',
  [STATUS_BLOQUEADO]: 'grey',
  [STATUS_APROVADO]: 'info',
  [STATUS_AGUARDANDO_FATURAMENTO]: 'primary',
  [STATUS_ERRO]: 'error',
  [STATUS_CANCELADO]: 'grey',
  [STATUS_FATURADO]: 'success',
  [STATUS_PARCIALMENTE_FATURADO]: 'warning',
  [STATUS_EM_TRANSPORTE]: 'info',
  [STATUS_FINALIZADO]: 'success',
  [STATUS_PARCIALMENTE_DEVOLVIDO]: 'brown',
  [STATUS_DEVOLVIDO]: 'brown',
}

const SUGESTAO_STATUS = {
  [STATUS_PENDENTE]: [STATUS_APROVADO],
  [STATUS_BLOQUEADO]: [STATUS_APROVADO],
  [STATUS_APROVADO]: [STATUS_BLOQUEADO],
  [STATUS_AGUARDANDO_FATURAMENTO]: [STATUS_CANCELADO],
  [STATUS_ERRO]: [STATUS_APROVADO],
  [STATUS_FATURADO]: [STATUS_EM_TRANSPORTE],
  [STATUS_PARCIALMENTE_FATURADO]: [STATUS_PARCIALMENTE_FATURADO],
  [STATUS_EM_TRANSPORTE]: [STATUS_FINALIZADO],
  [STATUS_PARCIALMENTE_DEVOLVIDO]: [STATUS_DEVOLVIDO],
}

const STATUS_PERMITIDOS_EXCLUSAO = [
  STATUS_PENDENTE,
  STATUS_APROVADO,
]

const STATUS_PERMITIDOS_EDICAO = [
  ...STATUS_PERMITIDOS_EXCLUSAO,
  STATUS_PARCIALMENTE_FATURADO,
  STATUS_ERRO,
]

const STATUS_PERMITIDOS_FATURAR = [
  STATUS_APROVADO,
  STATUS_AGUARDANDO_FATURAMENTO,
  STATUS_PARCIALMENTE_FATURADO,
  STATUS_CANCELADO,
  STATUS_ERRO,
]

const STATUS_NAO_PERMITIDOS_MOVIMENTAR = [
  STATUS_AGUARDANDO_FATURAMENTO,
  STATUS_PARCIALMENTE_FATURADO,
  STATUS_PARCIALMENTE_DEVOLVIDO,
  STATUS_DEVOLVIDO,
  STATUS_FINALIZADO,
  STATUS_CANCELADO,
]

const STATUS_POS_FATURAMENTO = [
  STATUS_AGUARDANDO_FATURAMENTO,
  STATUS_FATURADO,
  STATUS_PARCIALMENTE_FATURADO,
  STATUS_PARCIALMENTE_DEVOLVIDO,
  STATUS_DEVOLVIDO,
  STATUS_EM_TRANSPORTE,
  STATUS_FINALIZADO,
  STATUS_ERRO,
]

const STATUS_TRANSICOES = {
  [STATUS_ERRO]: [STATUS_APROVADO],
  [STATUS_PENDENTE]: [
    STATUS_APROVADO,
    STATUS_CANCELADO,
  ],

  [STATUS_APROVADO]: [
    STATUS_AGUARDANDO_FATURAMENTO,
    STATUS_BLOQUEADO,
  ],

  [STATUS_AGUARDANDO_FATURAMENTO]: [
    STATUS_FATURADO,
    STATUS_PARCIALMENTE_FATURADO,
    STATUS_ERRO,
  ],

  [STATUS_PARCIALMENTE_FATURADO]: [
    STATUS_FATURADO,
    STATUS_PARCIALMENTE_DEVOLVIDO,
    STATUS_DEVOLVIDO,
    STATUS_ERRO,
  ],

  [STATUS_FATURADO]: [
    STATUS_EM_TRANSPORTE,
    STATUS_FINALIZADO,
    STATUS_PARCIALMENTE_DEVOLVIDO,
    STATUS_DEVOLVIDO,
  ],

  [STATUS_EM_TRANSPORTE]: [
    STATUS_FINALIZADO,
  ],

  [STATUS_BLOQUEADO]: [
    STATUS_APROVADO,
    STATUS_CANCELADO,
  ],
}

const STATUS_JUSTIFICAVEIS = [
  STATUS_BLOQUEADO,
  STATUS_CANCELADO,
  STATUS_ERRO,
]

export {
  STATUS_PENDENTE,
  STATUS_BLOQUEADO,
  STATUS_APROVADO,
  STATUS_AGUARDANDO_FATURAMENTO,
  STATUS_FATURADO,
  STATUS_PARCIALMENTE_FATURADO,
  STATUS_PARCIALMENTE_DEVOLVIDO,
  STATUS_DEVOLVIDO,
  STATUS_ERRO,
  STATUS_CANCELADO,
  STATUS_EM_TRANSPORTE,
  STATUS_FINALIZADO,

  DESCRICAO_STATUS,
  DETALHES_STATUS,
  COR_STATUS,

  STATUS_PERMITIDOS_EXCLUSAO,
  STATUS_PERMITIDOS_EDICAO,
  STATUS_PERMITIDOS_FATURAR,
  STATUS_NAO_PERMITIDOS_MOVIMENTAR,
  STATUS_POS_FATURAMENTO,
  STATUS_JUSTIFICAVEIS,

  SUGESTAO_STATUS,
  STATUS_TRANSICOES,

  TIPO_COBRANCA_LIGACAO,
  TIPO_COBRANCA_EMAIL,
  TIPO_COBRANCA_APLICATIVO,

  DESCRICAO_TIPO_COBRANCA,
}
